import TableDraggableList from './TableDraggableList';

export default TableDraggableList;
